const texts = [
	{
		success:'การสมัครเป็นผู้ขายสำเร็จ',
	},
	{
		success:'Seller registration complete',
	}
];

export default texts;